import { Component } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { InitNewRowEvent, RowInsertedEvent, RowRemovedEvent, RowUpdatedEvent } from 'devextreme/ui/data_grid';
import { ModelService } from '../../Services/model.service';
import { Message } from '../../Model/System/Message';
import { FotoWareImportSettingsService } from '../../Services/fotoWare/fotoWareImportSettings.service';
import { FotoWareImportSettings } from '../../Model/recurringJobs/fotoWare/fotoWareImportSettings';

@Component({
    selector: 'fotoWareImport',
    templateUrl: 'fotoWareImport.component.html',
    standalone: false
})
export class FotoWareImportComponent {
  fotoWareImportSettings: FotoWareImportSettings[] = [];

  constructor(
    public modelService: ModelService,
    public fotoWareImportSettingsService: FotoWareImportSettingsService
  ) {
    this.onRowRemoved = this.onRowRemoved.bind(this);
    this.onRowUpdated = this.onRowUpdated.bind(this);
    this.onRowInserted = this.onRowInserted.bind(this);
    this.loadSettings();
  }

  async loadSettings() {
    this.fotoWareImportSettings = await lastValueFrom(this.fotoWareImportSettingsService.getAll());
    this.fotoWareImportSettings.forEach((setting: FotoWareImportSettings) => {
      setting.time = new Date(setting.time);
    });
  }

  onInitNewRow(event: InitNewRowEvent<FotoWareImportSettings>) {
    event.data.active = true;
    event.data.overlapDays = 45;
    event.data.fullSyncIntervalDays = 7;
  }

  async onRowInserted(event: RowInsertedEvent<FotoWareImportSettings>) {
    const created = await lastValueFrom(this.fotoWareImportSettingsService.create(event.data));
    event.data.id = created.id;
    event.data.clientSecret = created.clientSecret;
  }

  async onRowUpdated(event: RowUpdatedEvent<FotoWareImportSettings>) {
    const updated = await lastValueFrom(this.fotoWareImportSettingsService.update(event.data));
    event.data.clientSecret = updated.clientSecret;
  }

  async onRowRemoved(event: RowRemovedEvent<FotoWareImportSettings>) {
    await lastValueFrom(this.fotoWareImportSettingsService.delete(event.data.id));
  }

  isManager(): boolean {
    const claim = this.modelService.loginService.currentUser.currentClaim;
    return claim == 'MANAGER' || claim == 'ADMIN';
  }

  async testConnection(setting: FotoWareImportSettings) {
    const result = await lastValueFrom(this.fotoWareImportSettingsService.testConnection(setting.id));
    const message = new Message(result.message);
    if (!result.success)
      message.type = 'Error';
    this.modelService.systemService.notify(message);
  }

  run(setting: FotoWareImportSettings, fullSync: boolean) {
    this.fotoWareImportSettingsService.run(setting.id, fullSync).subscribe(
      () => {
        this.modelService.systemService.notify(new Message('Import Job wurde gestartet.'));
      },
      () => {
        const message = new Message();
        message.type = 'Error';
        message.message = 'Fehler beim manuellen starten';
        this.modelService.systemService.notify(message);
      }
    );
  }
}
